const SDK_VERSION = '7.78.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
